import React from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from 'react-router-dom';
import { connect } from 'react-redux';
import PaymentTerminalLanding from './paymentTerminalLandingPageCopy';
import PaymentTerminalStagePayment from '@containers/PaymentTerminalStagePayment';
import PaymentTerminalReceipt from '@containers/PaymentTerminalReceipt';
import PaymentTerminalCheckDetails from '../PaymentTerminalCheckDetails/indexRevamp';
import Stage from '../Stage/index';
import { APP_CONFIG } from '@constants';

const PaymentTerminal = () => {
  return (
    <Router>
      <div className="h-100">
        <Routes>
          <Route exact path={`${APP_CONFIG.BASE_URL}/paymentTerminal/checks`} component={<PaymentTerminalLanding/>} />
          <Route exact path={`${APP_CONFIG.BASE_URL}/paymentTerminal/details`} component={<PaymentTerminalCheckDetails/>} />
          <Route exact path={`${APP_CONFIG.BASE_URL}/paymentTerminal/stage`} component={<Stage/>} />
          <Route exact path={`${APP_CONFIG.BASE_URL}/paymentTerminal/stagePayment/:checkId`} component={<PaymentTerminalStagePayment/>} />
          <Route exact path={`${APP_CONFIG.BASE_URL}/paymentTerminal/receipt/:checkId`} component={<PaymentTerminalReceipt/>} />
        </Routes>
      </div>
    </Router>
  );
};

export default connect(
  null,
  null
)(PaymentTerminal);
